import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-delayed-service-uncheck',
  templateUrl: './modal-delayed-service-uncheck.component.html',
  styleUrls: ['./modal-delayed-service-uncheck.component.css'],
})
export class ModalDelayedServiceUncheckComponent {
  constructor(private readonly activeModal: NgbActiveModal) {}

  close(): void {
    this.activeModal.close(false);
  }

  confirm(): void {
    this.activeModal.close(true);
  }
}
